import { render, staticRenderFns } from "./ClubInfoModalContent.vue?vue&type=template&id=470c65d9&"
import script from "./ClubInfoModalContent.vue?vue&type=script&lang=js&"
export * from "./ClubInfoModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470c65d9')) {
      api.createRecord('470c65d9', component.options)
    } else {
      api.reload('470c65d9', component.options)
    }
    module.hot.accept("./ClubInfoModalContent.vue?vue&type=template&id=470c65d9&", function () {
      api.rerender('470c65d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/mobile/Club/components/dependencies/ClubInfoModal/ClubInfoModalContent.vue"
export default component.exports